





























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import TextField from '@/components/atoms/TextField/TextField.vue';

import { FilledButton } from '@/components/molecules';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import eventBus from '@/utils/eventBus.js';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { treatError } from '@/utils';
import AdminService from '@/api/AdminService';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';

@Component({
  components: { TextField, FilledButton, Typography }
})
export default class KeywordDetail extends Vue {
  @Prop({ required: true }) data: any;

  service = new AdminService();

  formData: any = {};

  loading = false;

  get formDataDefault() {
    return {
      ...this.data
    };
  }

  @Watch('data')
  async changedData() {
    this.formData = { ...this.formDataDefault };
  }

  closeModal() {
    eventBus.$emit('setSideModalVisible', false);
  }

  async createKeyword() {
    try {
      this.loading = true;

      await this.service.createKeywords([this.formData.name]);

      this.$notification('Success');
      eventBus.$emit('reloadKeywords', true);
      this.formData.name = '';
      setTimeout(() => {
        setFocusOnFirstInput('.keyword-details__group input');
      });
    } catch (e) {
      console.error(e);
      treatError(e);
    } finally {
      this.loading = false;
    }
  }

  deleteKeyword() {
    const onConfirm = async () => {
      try {
        this.loading = true;
        await this.service.deleteKeyword(this.formData.id);
        this.$notification('Success');
        eventBus.$emit('reloadKeywords', true);
        eventBus.$emit('closeModal');
        this.closeModal();
      } catch (e) {
        console.error(e);
        treatError(e);
      } finally {
        this.loading = false;
      }
    };
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'confirmationModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        type: 'delete',
        title: `Are you sure?`,
        description: `Do you want to delete this keyword:<br/><b>${
          this.data.name
        }</b>`,
        confirmLabel: 'Yes',
        cancelLabel: 'No',
        onConfirm,
        onClose: () => eventBus.$emit('closeModal')
      }
    );
  }

  mounted() {
    if (this.data.new) setFocusOnFirstInput('.keyword-details__group input');
  }

  created() {
    this.changedData();
  }
}
